var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMaskito } from "@maskito/react";
import { TextField } from "@opala-ds/react";
import { useFormContext } from "react-hook-form";
import { digitsOnlyMask } from "../../utils/masks";
export default function SchoolTeamRegistrationRegistrationProofSearchForm() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = useFormContext(), register = _j.register, errors = _j.formState.errors;
    var inepMaskRef = useMaskito({ options: digitsOnlyMask });
    var registerNumberMaskRef = useMaskito({ options: digitsOnlyMask });
    return (_jsxs("div", __assign({ className: "col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx(TextField, __assign({ label: "INEP da Escola", placeholder: "Digite o INEP da Escola", maxLength: 8, helperText: (_c = (_b = (_a = errors.schoolTeamRegistration) === null || _a === void 0 ? void 0 : _a.inep) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: ((_d = errors.schoolTeamRegistration) === null || _d === void 0 ? void 0 : _d.inep) ? "critical" : "default" }, register("schoolTeamRegistration.inep"), { ref: function (node) {
                    inepMaskRef(node);
                    register("schoolTeamRegistration.inep").ref(node);
                } })), _jsx(TextField, __assign({ label: "N\u00FAmero de inscri\u00E7\u00E3o da Escola", placeholder: "Digite o n\u00FAmero de inscri\u00E7\u00E3o da Escola", helperText: (_g = (_f = (_e = errors.schoolTeamRegistration) === null || _e === void 0 ? void 0 : _e.codigoInscricao) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : "", variant: ((_h = errors.schoolTeamRegistration) === null || _h === void 0 ? void 0 : _h.codigoInscricao)
                    ? "critical"
                    : "default" }, register("schoolTeamRegistration.codigoInscricao"), { ref: function (node) {
                    registerNumberMaskRef(node);
                    register("schoolTeamRegistration.codigoInscricao").ref(node);
                } }))] })));
}
